import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/demo/service/language.service';
import { NgxTranslateModule } from 'src/app/translate.module';

@Component({
    selector: 'app-progress-loader',
    standalone: true,
    imports: [CommonModule, ProgressSpinnerModule, NgxTranslateModule],
    template: `
        <div class="loader-content">
            <span class="dialog-title mb-2">{{ title | translate }}</span>
            <div class="spinner"></div>
            <p class="my-2">{{ 'Just a moment' | translate }}...</p>
        </div>
    `,
    styles: [
        `
            .spinner {
                width: 56px;
                height: 56px;
                display: grid;
                border: 4.5px solid #0000;
                border-radius: 50%;
                border-color: #dbdcef #0000;
                animation: spinner-e04l1k 1s infinite linear;
            }

            .spinner::before,
            .spinner::after {
                content: '';
                grid-area: 1/1;
                margin: 2.2px;
                border: inherit;
                border-radius: 50%;
            }

            .spinner::before {
                border-color: #474bff #0000;
                animation: inherit;
                animation-duration: 0.5s;
                animation-direction: reverse;
            }

            .spinner::after {
                margin: 8.9px;
            }

            @keyframes spinner-e04l1k {
                100% {
                    transform: rotate(1turn);
                }
            }

            .dialog-title {
                font-size: 1.15rem;
                font-weight: 500;
                display: inline-block;
                text-align: center;
                color: var(--text-color);
                margin-bottom: var(--margin-medium);
            }

            .loader-content {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 2rem;
            }

            p {
                margin-top: 1rem;
                font-size: 1rem;
                color: var(--text-color);
            }
        `,
    ],
})
export class ProgressLoaderComponent {
    title: string;
    selectedLanguage: any = null;

    constructor(
        public config: DynamicDialogConfig,
        private translate: TranslateService,
        private languageService: LanguageService
    ) {
        this.title = this.config.data?.title || 'Loading';
    }

    ngOnInit() {
        this.initializeLocale();
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translate.use(language);
        this.languageService.setLanguage(language);
    }
}
